import {intOrNull} from "@/api/lib";

export default class UserQuestionnaireTopic {
    public pk: number|null
    public userQuestionnairePk: number|null
    public topicId: number
    public progress: number

    constructor(data: any) {
        this.pk = intOrNull(data.pk)
        this.userQuestionnairePk = intOrNull(data.userQuestionnairePk)
        this.topicId = parseInt(data.topicId)
        this.progress = parseInt(data.progress)
    }
}